import Grid from '@mui/material/Grid';

import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import type { HeroFullOverlayContent } from '@/components/TopLevelComponents/HeroFullOverlay/HeroFullOverlay';

import ProgressBox from './ProgressBox/ProgressBox';
import useStyles from './ProgressOverlay.styles';

interface Props {
  slides: HeroFullOverlayContent[];
  activeSlideIndex: number;
  onProgressBarClick: (index: number) => void;
}

export default function ProgressOverlay({
  slides,
  activeSlideIndex,
  onProgressBarClick,
}: Props) {
  const { classes } = useStyles();

  return (
    <GridContainer fixed wrapperProps={{ className: classes.container }}>
      <Grid>
        <div className={classes.progressBoxesWrapper}>
          {slides?.map((slide, index) => (
            <ProgressBox
              active={activeSlideIndex === index}
              key={slide?.sys.id}
              slide={slide}
              onClick={() => onProgressBarClick(index)}
            />
          ))}
        </div>
      </Grid>
    </GridContainer>
  );
}
